module.exports = __webpack_public_path__ + "static/app_store-a6b57454d3bc3c2ee7c90dee966c85ba.svg";